import { computed, onBeforeMount, ref } from 'vue'
import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import { useStore } from 'vuex'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagPaaHoldStepOne',
    components: {
        FormInputDropdown,
        FormCheckbox,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const teamName = ref('')
        const isFighter = ref(false)
        const shirtSize = ref('')
        const isFighterFreeLunch = ref(false)
        const isChild = ref(false)

        const tshirtSizes = computed(() => {
            const array = []
            props.tshirtSizes.forEach((size) => {
                array.push({
                    name: size.displayName,
                    value: size.value
                })
            })
            return array
        })

        const teams = computed(() => {
            const array = []
            if (props.holdList) {
                props.holdList.forEach((hold) =>
                    array.push({ name: hold.name, value: hold.holdKode })
                )
            }

            return array
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM
            )

            if (storedFields) {
                updateLocalRefs([
                    {
                        name: 'teamName',
                        value: getFieldValue(storedFields, 'teamName')
                    },
                    {
                        name: 'isFighter',
                        value: getFieldValue(storedFields, 'isFighter')
                    },
                    {
                        name: 'shirtSize',
                        value: getFieldValue(storedFields, 'shirtSize')
                    },
                    {
                        name: 'isFighterFreeLunch',
                        value: getFieldValue(storedFields, 'isFighterFreeLunch')
                    },
                    {
                        name: 'isChild',
                        value: getFieldValue(storedFields, 'isChild')
                    }
                ])
            }

            if (props.holdId) {
                teamName.value = props.holdId
                fieldsConfig.find((field) => field.name === "teamName").value = props.holdId
            }

            store.dispatch('donation/teams', { stafetId: props.stafetId })
        })

        const updateLocalRefs = (fields) => {
            fields.forEach((field) => {
                if (field.value === undefined || field.value === null) return
                fieldsConfig.find((item) => item.name === field.name).value =
                    field.value
                switch (field.name) {
                    case 'teamName':
                        teamName.value = field.value
                        return
                    case 'isFighter':
                        isFighter.value = field.value
                        return
                    case 'shirtSize':
                        shirtSize.value = field.value
                        return
                    case 'isFighterFreeLunch':
                        isFighterFreeLunch.value = field.value
                        return
                    case 'isChild':
                        isChild.value = field.value
                        return
                    default:
                        return
                }
            })
        }

        const validateField = (fieldName, value) => {
            updateLocalRefs([{ name: fieldName, value: value }]) // update local refs and keep in sync with fieldsConfig
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                if (field.dependentField) {
                    const dependentField = fieldsConfig.find(
                        (item) => item.name === field.dependentField
                    )

                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value
                    }
                }

                field.value = value
                fieldValidator(field)
            }
        }

        const stepModel = computed(() => {
            return fieldsConfig
        })

        const handleErrorMessage = (fieldName) => {
            const field = fieldsConfig.find((field) => field.name === fieldName)
            return !field?.isValid && props.displayInputError
        }

        return {
            teamName,
            isFighter,
            shirtSize,
            tshirtSizes,
            isFighterFreeLunch,
            isChild,
            teams,
            stepModel,
            validateField,
            handleErrorMessage
        }
    }
}
